<app-tabla
  [totalCount]="totalCount"
  [datos]="asignacions"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [showHijos]="true"
  [emptyState]="{ title: 'Todavía no hay asignaciones' }"
></app-tabla>
